<a href="https://apps.apple.com/us/app/sportys-pilot-training/id1272775528" target="_blank">
  <div class="card">
    <div class="card-background"></div>
    <div class="card-header">
      Take Pilot Training
      <br>
      on-the-go!
    </div>
    <div class="card-body bg-primary">
      <img src="https://dl.videos.sportys.com/onlinecourse/images/devices-image@3x.png">
    </div>
    <div class="card-footer">
      <div>
        <a class="btn-android" target="_blank"
          href='https://play.google.com/store/apps/details?id=com.sportys.pilottraining'></a>
      </div>
      <div>
        <a class="btn-ios" target="_blank"
          href="https://itunes.apple.com/us/app/sportys-pilot-training/id1272775528?mt=8"></a>
      </div>
    </div>
  </div>
</a>